import { AttachmentField } from '@src/main/modules/messages/ui/mailbox/components/new-message/fields/AttachmentField';
import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import { CancelButton } from '@src/main/shared/ui/components/button/cancel/CancelButton';
import { SendButton } from '@src/main/shared/ui/components/button/send/SendButton';
import { BaseSyntheticEvent, FC } from 'react';
import { Control } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

interface Props {
  control: Control<NewMessageFormData>;
  isLoading?: boolean;
  onCancel?: () => void;
  styles: Record<string, string>;
  handleSubmit: (onValid: (data: NewMessageFormData) => void) => (e?: BaseSyntheticEvent) => void;
  onSubmit: (data: NewMessageFormData) => void;
}

export const FormButtons: FC<Props> = ({
  control,
  isLoading,
  onCancel,
  styles,
  handleSubmit,
  onSubmit,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <AttachmentField control={control} styles={styles} />
      <div className={styles['form-buttons']}>
        <CancelButton onClick={onCancel || (() => navigate('/messages/mailbox'))} />
        <SendButton onClick={handleSubmit(onSubmit)} disabled={isLoading} />
      </div>
    </>
  );
};
